import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axiosInstance from "../../axios/axiosInstance";
import { Zone } from "./types";

interface ZoneSelectionPageProps {
  onSelectZones: (zones: Zone[]) => void;
  onClose: () => void;
}

export default function ZoneSelectionPage({
  onSelectZones,
  onClose,
}: ZoneSelectionPageProps) {
  const [zones, setZones] = useState<Zone[]>([]);

  const handleZoneToggle = (zoneId: number) => {
    setZones((prev) =>
      prev.map((zone) =>
        zone.id === zoneId ? { ...zone, selected: !zone.selected } : zone
      )
    );
  };

  const handleAddSelected = () => {
    const selectedZones = zones.filter((zone) => zone.selected);
    onSelectZones(selectedZones);
    onClose();
  };

  const handleGetZones = async () => {
    // setLoading(true);
    try {
      const resp: any = await axiosInstance.get(`/api/zone/all`);
      if (resp.status === 200) {
        setZones(resp.data.data || []);
      }
    } catch (error: any) {
      toast.error("Error getting users");
    }
  };

  useEffect(() => {
    handleGetZones();
  }, []);
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white dark:bg-neutral-800 rounded-2xl shadow-xl max-w-5xl w-full p-8 relative mt-8">
        <div className="relative  bg-neutral-50 dark:bg-neutral-900">
          <header className="border-b bg-white dark:bg-neutral-800">
            <div className="container mx-auto px-4 py-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <i className="fa-solid fa-map-location-dot text-2xl text-neutral-800 dark:text-white"></i>
                  <span className="text-xl dark:text-white">Select Zones</span>
                </div>
                <button
                  onClick={onClose}
                  className="text-neutral-600 dark:text-neutral-400 hover:text-neutral-800 dark:hover:text-white"
                >
                  <i className="fa-solid fa-xmark text-2xl"></i>
                </button>
              </div>
            </div>
          </header>

          <main className="m-h-120 container mx-auto px-4 py-10">
            {/* <div className="mb-10">
              <h1 className="text-3xl font-semibold mb-2 dark:text-white">
                Zone Selection
              </h1>
              <p className="text-neutral-600 dark:text-neutral-400 text-lg">
                Select zones to target your notification.
              </p>
            </div> */}

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
              {zones.map((zone) => (
                <div
                  key={zone.id}
                  className={`bg-white dark:bg-neutral-800 rounded-xl border dark:border-neutral-700 p-6 cursor-pointer transition-all ${zone.selected
                      ? "ring-2 ring-neutral-800 dark:ring-neutral-600"
                      : "hover:shadow-lg"
                    }`}
                  onClick={() => handleZoneToggle(zone.id)}
                >
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-xl font-semibold text-neutral-800 dark:text-white">
                      {zone.zone_name}
                    </h3>
                    <div
                      className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${zone.selected
                          ? "bg-neutral-800 dark:bg-neutral-600 border-neutral-800 dark:border-neutral-600"
                          : "border-neutral-300 dark:border-neutral-600"
                        }`}
                    >
                      {zone.selected && (
                        <i className="fa-solid fa-check text-white text-sm"></i>
                      )}
                    </div>
                  </div>
                  <div className="space-y-2">
                    <p className="text-sm text-neutral-600 dark:text-neutral-400">
                      Leader:
                    </p>
                    <div className="flex flex-wrap gap-2">
                      <span
                        key={zone.leader?.name}
                        className="px-2 py-1 bg-neutral-100 dark:bg-neutral-700 rounded text-xs text-neutral-700 dark:text-neutral-300"
                      >
                        {zone.leader?.name}
                      </span>
                    </div>
                  </div>
                  <div className="space-y-2">
                    <p className="text-sm text-neutral-600 dark:text-neutral-400">
                      Areas:
                    </p>
                    <div className="flex flex-wrap gap-2">
                      {/* {zone.users.map((user) => (
                        <span
                          key={user.address}
                          className="px-2 py-1 bg-neutral-100 dark:bg-neutral-700 rounded text-xs text-neutral-700 dark:text-neutral-300"
                        >
                          {area}
                        </span>
                      ))} */}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-8 flex justify-end max-w-4xl mx-auto">
              <button
                onClick={handleAddSelected}
                disabled={!zones.some((zone) => zone.selected)}
                className="flex items-center gap-2 bg-neutral-800 dark:bg-neutral-600 hover:bg-neutral-700 dark:hover:bg-neutral-500 text-white px-6 py-3 rounded-lg font-medium shadow transition disabled:bg-neutral-300 dark:disabled:bg-neutral-700"
              >
                <i className="fa-solid fa-plus"></i>
                Add Selected Zones
              </button>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
